import {
  doGet,
  doPost,
} from '@/http/index.js';
import axios from 'axios';

const actions = {
  getBookmarks: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/get-bookmarks',
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  deleteBookmark: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/delete-bookmark/${ id }`,
        method: 'DELETE',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  createBookmark: ({ commit }, requestData) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/create-bookmark',
        data: requestData,
        method: 'POST',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
};

export default {
  namespaced: true,
  actions,
};
